import React from 'react';

/**
 * A márka: a „kis Mortis” feje (a 2026-10-06-i végleges logó, K7 áttűnés:
 * C:\ccc\logo\vegleges → public/brand/) + „Mortis” világos, „Engine” halvány — a bot oldala (bot.mortisengine.com); a Codex oldalán „Codex”.
 * A fej széle a sötét háttérbe olvad, ezért a látható rész a doboznál kisebb — a
 * menüsávban 36 px a jó méret. `size`: a logó pixelmérete (fejléc 36, ablak-címsor 22).
 */
export function BrandMark({ size = 36, className = '' }) {
  return (
    <span className={`inline-flex items-center gap-2 font-semibold tracking-[-0.01em] text-gray-50 whitespace-nowrap ${className}`}
          style={{ fontSize: size >= 30 ? 16 : 13 }}>
      <img src="/brand/mortis-head-64.png" srcSet="/brand/mortis-head-64.png 1x, /brand/mortis-head-128.png 2x"
           alt="" width={size} height={size} style={{ width: size, height: size }}
           className="object-contain" />
      <span>Mortis<span className="text-gray-500 font-medium">Engine</span></span>
    </span>
  );
}
